import React from 'react';
import clsx from 'clsx';
import { FeatureCardProps } from './types';
import { APP_STORE_URL, PLAY_STORE_URL } from '@/config';
import { Button } from '@/components/design-system/atoms/button';

const FeatureCard: React.FC<FeatureCardProps> = ({
  featureId,
  icon,
  title,
  description,
  details,
  buttonText,
  onButtonClick,
  showAppStoreButtons,
  className,
}) => {
  return (
    <div
      className={clsx(
        'flex flex-col items-start gap-2',
        'rounded-[24px] bg-white shadow-sm',
        'p-4 sm:px-5 sm:py-6',
        'h-auto',
        'w-[300px] min-w-[300px] sm:w-[364px] sm:min-w-[364px]',
        className
      )}
      data-feature-id={featureId}
    >
      {/* Icon */}
      <div className="flex h-[74px] w-[74px] items-center justify-center">{icon}</div>

      {/* Title */}
      <h3 className="text-4xl font-bold text-text-primary">{title}</h3>
      <div>
        {/* Description */}
        <p className="text-2xl font-medium text-text-primary">{description}</p>

        {/* Details */}
        <p className="text-2xl font-medium text-text-primary">{details}</p>
      </div>

      {/* App Store Buttons */}
      {showAppStoreButtons && (
        <div className="mt-4 flex flex-row gap-2 w-full">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center flex-1"
          >
            <img
              src={require('@assets/images/email/app-store.svg')}
              alt="Download on the App Store"
              className="w-auto h-[40px]"
            />
          </a>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center flex-1"
          >
            <img
              src={require('@assets/images/email/google-play.svg')}
              alt="Get it on Google Play"
              className="w-auto h-[40px]"
            />
          </a>
        </div>
      )}

      {/* Button */}
      {buttonText && (
        <Button
          variant="primary"
          size="large"
          onClick={onButtonClick}
          className="mt-auto w-full"
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export { FeatureCard };
